// extracted by mini-css-extract-plugin
export var adjacentSlide = "_su-9";
export var arrowButtonContainer = "_su-5";
export var arrowButtonIcon = "_su-6";
export var carouselArrowButton = "_su-2";
export var carouselElementContainer = "_su-1";
export var currentSlide = "_su-8";
export var left = "_su-3";
export var otherSlide = "_su-a";
export var productCarouselContainer = "_su-0";
export var right = "_su-4";
export var sliderOverflow = "_su-7";